export function getHalfCircleEndAngle(startAngle) {
  // Handle angles greater than 360 degrees
  startAngle = startAngle % 360;

  // Calculate the halfway point angle relative to the provided angle
  let halfwayPointAngle = (startAngle + 180) % 360;

  return halfwayPointAngle;
}

export function getAngleUpdate(angle, width, sign) {
  if (sign === "minus") {
    let nextAngle = angle - width;

    if (Math.sign(nextAngle) === -1) {
      nextAngle = 360 + nextAngle;
    }

    return nextAngle;
  } else {
    return angle + width;
  }
}

export function getDegreesWithGap(startAngle, gap = 10) {
  // Handle invalid input (non-numeric)
  if (isNaN(startAngle)) {
    throw new TypeError("startAngle must be a number");
  }

  // Handle negative or zero gap (return an array with startAngle)
  if (gap <= 0) {
    return [startAngle];
  }

  // Calculate the number of degrees based on gap
  const numDegrees = Math.ceil(360 / gap);

  // Create an array to store degrees
  const degrees = [];

  // Loop and populate the array with degrees
  for (let i = 0; i < numDegrees; i++) {
    const currentAngle = (startAngle + gap * i) % 360;
    degrees.push(currentAngle);
  }

  return degrees;
}

export function handleOverlayDown(
  { centerX, centerY, deltaX, deltaY },
  barAngle,
  onSuccess
) {
  return () => {
    // if (!event.target.closest("svg")) return; // Handle clicks outside the SVG
    const overlayBar = document.querySelector("#overlay-bar");
    let angle = Number(barAngle);

    const mainGroup = document.querySelector("#main-group");
    mainGroup.classList.remove("main-group");

    const handleMouseMove = (moveEvent) => {
      // if (!event.target.closest("svg")) return; // Handle dragging outside the SVG
      const pointA = [centerX, centerY];
      const pointB = [moveEvent.clientX, moveEvent.clientY];

      pointA[0] = pointA[0] + deltaX;
      pointA[1] = pointA[1] + deltaY;

      angle =
        (Math.atan2(pointB[1] - pointA[1], pointB[0] - pointA[0]) * 180) /
        Math.PI;

      angle -= 15;

      overlayBar.setAttribute("transform", `rotate(${angle})`);
    };

    const handleMouseUp = () => {
      onSuccess && onSuccess(angle);

      mainGroup.classList.add("main-group");

      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
  };
}
